module.exports = __webpack_public_path__ + "static/media/SOTA COSMOS ECLIPSE.3fcd91b7.png";